import React from 'react';
import PropTypes from 'prop-types';

function DetailItem(props) {
  const { header, text, textClass, isLink, isComposeText, wrapperClass } =
    props;
  return (
    <div className={`detail-item ${wrapperClass}`}>
      <p className="header">{header}</p>
      {!isComposeText ? (
        <>
          {isLink ? (
            <a
              href={text}
              target="_blank"
              rel="noreferrer"
              className={`text ${textClass || ''}`}
            >
              {text}
            </a>
          ) : (
            <p className={`text ${textClass || ''}`}>{text}</p>
          )}
        </>
      ) : (
        isComposeText
      )}
    </div>
  );
}

DetailItem.propTypes = {
  header: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textClass: PropTypes.string,
  wrapperClass: PropTypes.string,
  isLink: PropTypes.bool,
  isComposeText: PropTypes.node,
};

DetailItem.defaultProps = {
  textClass: '',
  text: '',
  wrapperClass: '',
  isLink: false,
  isComposeText: null,
};

export default DetailItem;
